import { render, staticRenderFns } from "./detail-save.vue?vue&type=template&id=4e966df1&"
import script from "./detail-save.vue?vue&type=script&lang=js&"
export * from "./detail-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports